export default __webpack_public_path__ + "static/media/4.1ec59be0.jpg";